import React, { useState } from "react";

// material components
import { Toolbar } from "@material-ui/core";
import { IconButton, Tooltip, Typography } from "@material-ui/core";
import AddCircleIcon from "@material-ui/icons/AddCircle";
import NotificationsIcon from '@material-ui/icons/Notifications';
import RefreshIcon from '@material-ui/icons/Refresh';
import CalculateIcon from '@mui/icons-material/Calculate';
import HourglassEmptyIcon from '@mui/icons-material/HourglassEmpty';
// constants
import { CREATE_MANUAL_INVENTORY_TITLE, INVENTORY,
    REFRESH_INVENTORY_ENTRIES, INVENTORY_COUNT, SET_INVENTORY_THRESHOLD,
    RECALCULATE_DAYS_OF_COVERAGE} from './constants';
import InventoryIcon from '@mui/icons-material/Inventory';

// import styling
import "../global/TableToolbar.css";
import "./InventoryToolbar.css";
import PropTypes from "prop-types";
import KeyboardBackspaceIcon from "@material-ui/icons/KeyboardBackspace";

class InventoryToolbar extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="toolbar">
                <Toolbar>
                    <div className="contextualMenu">
                        {(!this.props.creatingManualInventory && !this.props.settingInventoryThreshold && !this.props.creatingInventoryMap) ?
                            <>
                                <Tooltip title={CREATE_MANUAL_INVENTORY_TITLE}>
                                    <IconButton aria-label={CREATE_MANUAL_INVENTORY_TITLE}
                                        onClick={this.props.createManualInventory}>
                                        <AddCircleIcon />
                                    </IconButton>
                                </Tooltip>
                                <div>
                                    <Tooltip title={SET_INVENTORY_THRESHOLD}>
                                        <IconButton aria-label={SET_INVENTORY_THRESHOLD}
                                            onClick={this.props.setInventoryThreshold}>
                                            <NotificationsIcon />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                                <div>
                                    {this.props.isInventoryEntriesLoading ?
                                        <IconButton aria-label={REFRESH_INVENTORY_ENTRIES}
                                                    disabled={true}>
                                            <HourglassEmptyIcon />
                                        </IconButton>
                                        :
                                        <Tooltip title={REFRESH_INVENTORY_ENTRIES}>
                                            <IconButton aria-label={REFRESH_INVENTORY_ENTRIES}
                                                        onClick={this.props.refreshInventoryEntries}>
                                                <RefreshIcon />
                                            </IconButton>
                                        </Tooltip>
                                    }
                                </div>
                                { this.props.userIsAnAdmin && this.props.runRateCalculating ?
                                    <div>
                                        <IconButton aria-label={RECALCULATE_DAYS_OF_COVERAGE}
                                                    disabled={true}>
                                            <HourglassEmptyIcon />
                                        </IconButton>
                                    </div>
                                    :this.props.userIsAnAdmin && !this.props.runRateCalculating ?
                                        <div>
                                            <Tooltip title={RECALCULATE_DAYS_OF_COVERAGE}>
                                                <IconButton aria-label={RECALCULATE_DAYS_OF_COVERAGE}
                                                            onClick={this.props.recalculateDaysOfCoverage}>
                                                    <CalculateIcon />
                                                </IconButton>
                                            </Tooltip>
                                        </div>
                                        :null
                                }
                                <Tooltip title={INVENTORY_COUNT}>
                                        <IconButton aria-label={INVENTORY_COUNT}
                                            onClick={this.props.openInventoryMap}>
                                            <InventoryIcon />
                                        </IconButton>
                                    </Tooltip>
                            </>
                            :
                            <div className="contextualMenu">
                                <Tooltip title={"Back to menu"}>
                                    <IconButton aria-label={"Back to menu"} onClick={() => { this.props.handleClose() }} >
                                        <KeyboardBackspaceIcon />
                                    </IconButton>
                                </Tooltip>
                            </div>
                        }
                    </div>
                    <Typography className="titleTypography" variant="h6" id="tableTitle">
                        {this.props.title}
                    </Typography>
                </Toolbar>
            </div>

        )
    }
}

InventoryToolbar.propTypes = {
    title: PropTypes.string,
    createManualInventory: PropTypes.func,
    setInventoryThreshold: PropTypes.func,
    refreshInventoryEntries: PropTypes.func,
    recalculateDaysOfCoverage: PropTypes.func,
    creatingManualInventory: PropTypes.bool,
    settingInventoryThreshold: PropTypes.bool,
    handleClose: PropTypes.func
}

InventoryToolbar.defaultProps = {
    title: "",
    createManualInventory: () => { },
    setInventoryThreshold: () => { },
    refreshInventoryEntries: () => { },
    recalculateDaysOfCoverage: () => { },
    creatingManualInventory: false,
    settingInventoryThreshold: false,
    handleClose: () => { }
}

export default InventoryToolbar;